// Opens the Intercom messenger when it's available (booted via intercom_script_tag),
// falling back to an email to support if it isn't.
export const openSupport = () => {
  if (typeof window !== "undefined" && typeof window.Intercom === "function") {
    window.Intercom("show")
    return "intercom"
  }

  window.location.assign("mailto:support@blinkist.com")
  return "mailto"
}
